export default "__VITE_ASSET__gSpOa0Xx__"